var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.8C19 16.2536 20.2536 15 21.8 15H30.2C31.7464 15 33 16.2536 33 17.8V33.2C33 34.7464 31.7464 36 30.2 36H21.8C20.2536 36 19 34.7464 19 33.2V17.8Z",
    stroke: "#456173",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9997,
    cy: 32.4997,
    r: 1.16667,
    fill: "#456173"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.667 18.5H28.3337",
    stroke: "#456173",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2ab4a042a5026d9a8d32326aca052f76.svg";
export { ForwardRef as ReactComponent };